/** 后端 GET /api/option 不返回的敏感键判定（与 newapi controller/option.go 一致） */

const SENSITIVE_EXACT_KEYS = new Set([
  'discord.client_secret',
  'oidc.client_secret',
  'model_deployment.ionet.api_key',
])

const SENSITIVE_SUFFIXES = ['Secret', 'Token', 'Key', 'secret', 'api_key', 'webhook_url'] as const

export function isSensitiveKey(key: string): boolean {
  if (SENSITIVE_EXACT_KEYS.has(key)) return true
  return SENSITIVE_SUFFIXES.some((suffix) => key.endsWith(suffix))
}

export {
  OPTION_META,
  READONLY_OPTION_KEYS,
  filterSaveableKeys,
  formatSaveScopeLabel,
} from './optionMeta'

export const SENSITIVE_PLACEHOLDER = '已配置，留空不修改'
